import { AxiosRequestConfig } from 'axios';

import { get } from '~/App/helpers/cookie';
import { IUser } from '~/types/IUser';
import { siteAxios } from '.';

type Arguments = AxiosRequestConfig;
type ArgumentsWithActivationToken = AxiosRequestConfig & {
  activationToken: string;
};

type VerifyEmailArguments = {
  email: string;
  token: string;
};

type VerifyEmailResponse = {
  confirmationNeeded: boolean;
};

export const users = {
  edit: (args: Arguments) =>
    siteAxios({
      url: `/api/v2/mw/users/me`,
      method: 'put',
      headers: {
        'X-Session-Key': get('secretKey')
      },
      data: {
        ...args.data
      },
      ...args
    }),
  activate: (args: ArgumentsWithActivationToken) =>
    siteAxios({
      url: `/api/v2/mw/users/activate/${args.activationToken}`,
      method: 'get'
    }),
  activateSubscription: (args: Arguments) =>
    siteAxios({
      url: `/api/v2/mw/users/subscriptions/activate`,
      method: 'post',
      data: {
        ...args.data
      },
      headers: {
        'X-Session-Key': get('secretKey')
      }
    }),
  show: async () => {
    const { data } = await siteAxios.get<IUser>(`/api/v2/mw/users/me`, {
      headers: {
        'X-Session-Key': get('secretKey')
      }
    });

    return data;
  },
  addMetadata: (args: Arguments) =>
    siteAxios({
      url: `/api/v2/mw/users/me/add_metadata`,
      method: 'post',
      headers: {
        'X-Session-Key': get('secretKey')
      },
      data: {
        metadata: { ...args.data }
      }
    }),
  addSubscription: (args: Arguments) =>
    siteAxios({
      url: `/api/v2/mw/users/subscriptions`,
      method: 'post',
      data: {
        ...args.data
      },
      headers: {
        'X-Session-Key': get('secretKey')
      }
    }),
  resendActivion: () =>
    siteAxios({
      url: `/api/v2/mw/users/me/resend_activation`,
      method: 'post',
      headers: {
        'X-Session-Key': get('secretKey')
      },
      responseType: 'json'
    }),
  verifyEmail: (args: VerifyEmailArguments) =>
    siteAxios.post<VerifyEmailResponse>('/api/v2/mw/users/verify_email', args, {
      headers: {
        'X-Session-Key': get('secretKey')
      },
      responseType: 'json'
    })
};
